/**
 * colorUtils 
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import tinycolor from "tinycolor2";

export const getColorUtils = (color: tinycolor.ColorInput) => tinycolor(color);

export const colorEquals = tinycolor.equals;
